import {Row} from '../../components/Row';
import React, {memo, useCallback} from 'react';
import {Column} from '../../components/Column';
import {Widget} from '../../components/Widget';
import {Button} from '../../components/Button';

import warningIcon from '../../assets/images/icons/sensor/warning.png';
import {Container} from '../../components/Container';
import {useHistory} from 'react-router-dom';
import {Sensor} from '../../components/ItemList/sensor';
import {useSetSelector} from '../../hooks/set-selector';
import {useFilterSelector} from '../../hooks/filter-selector';
import {useLocalization} from "../../hooks/localization";
import {useDispatch} from "react-redux";
import {backButtonToggle, groupSettingAction} from "../../store/ui/actions";

export const SensorScreen = memo(function SensorScreen() {
    const {t} = useLocalization();
    const inputTypeSet = useSetSelector(state => state.control.inputTypeList);
    const sensorList = useFilterSelector(
        state => state.control.inputList,
        i => inputTypeSet[i.type_id]?.primitive_name === "sensor",
        [inputTypeSet]
    ).sort((a, b) => (a?.sensor_settings?.["order"] > b?.sensor_settings?.["order"] ? 1 : -1))
    const history = useHistory();
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    dispatch(groupSettingAction({visible: false}));
    const goSettingsPage = useCallback(() => {
        history.push('/settings/sensors');
    }, [history]);

    return (
        <Container>
            <div className="page-wrapper">
                <Row>
                    <Column min={3} max={6}>
                        <Widget style={{padding: 0}}>
                            <Button icon={warningIcon} title={t('SENSOR_SETTINGS')} textStyle={{color: '#ffca00'}}
                                    onClick={goSettingsPage}/>
                        </Widget>
                    </Column>
                    {
                        sensorList.map(sensor => (
                                <Sensor key={`sensor_${sensor.id}`}
                                        sensor={sensor}/>
                            ),
                        )
                    }
                </Row>
            </div>
        </Container>
    );
});
